import React from 'react'
import Lang from "@components/Lang/Lang"
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {Tabs, Badge,Pagination, Empty, Spin,message,Alert} from 'antd';
import AfterSaleContent from "./component/AfterSaleContent";
import InputForm from "./component/InputForm";
import {postClaimDemageList,postHandelExcel,downloadExcel} from '@/api/afterSale';
import PageCommon from  "@components/PageCommon/PageCommon";
import UploadFile from '@/components/UploadFile/UploadFile';
import "./index.less";
class AfterSale extends React.Component {
    constructor(props) {
        super(props)

        let {pathname} = props.location;
        let list = pathname.split("/")
        this.key = list[list.length-1];

        this.state = {
            tabKey: '1',//1:待审核列表.2:已审核列表 3:待付款
            auditingNum: '',
            obligationNum:'',
            loading: true,
            filter: {
                businessPlatform:this.key=='customerInitiated'?'essaone':'mg',
                buyerCodeOrName: '',
                cdOrderCode: '',
                poCode: '',
                statusMg:''
            },
            list: [],
            pagination: {
                pageSize: 50,
                total: 0,
                pageNum: 1
            },
            // 上传设置
            uploadSetting : {
                name: 'fileShippingOut',
                accept:'.xlsx, .xls',
                showUploadList: false,
                // customRequest:this.handleUpload.bind(this),
                // beforeUpload:this.beforeUpload.bind(this),
                replace:true,
            },
        }
        this.onRefPageCommonChild = null;
    }

    /** pagination 分页器的 onChange*/
    paginationOnChange(page, pageSize) {
        // console.log('Page: ', page, pageSize);
        this.setState({
            pagination: {
                ...this.state.pagination,
                pageNum: page,
                pageSize: pageSize,
            }
        }, () => {
            this.getList()
        })
    }

    getList() {
        this.setState({
            loading: true
        }, () => {
            var postData = {
                status:Number(this.state.tabKey),
                pagingQuery: {
                    pageIndex: this.state.pagination.pageNum,
                    pageSize: this.state.pagination.pageSize,
                },
            }
            let filter = this.state.filter;
            for(var key in filter){
                if(filter[key]!==''){
                    postData[key] = filter[key];
                }
            }
            postClaimDemageList(postData).then(res => {
                let model = res.data.model||{};
                this.setState({
                    list: res.data.models || [],
                    pagination: res.data.paging || {},
                    loading: false,
                    waitHandleNum:this.key=='customerInitiated'?model.buyerWaitHandleNum:model.esssaoneWaitHandleNum,
                    waitPyaNum:this.key=='customerInitiated'?model.buyerWaitPyaNum:model.esssaoneWaitPyaNum,
                });
            })
        })
    }

    getFormData(data) {
        this.setState({
            filter: {
                ...this.state.filter,
                ...data,
            },
            pagination: {
                ...this.state.pagination,
                pageNum: 1,
            },
        }, () => {
            this.getList()
        })
    }

    /*tabs onChange*/
    tabsOnChange(key) {
        this.setState({
            tabKey: key,
            list: [],
            pagination:{
                pageNum:1,
                pageSize:this.state.pagination.pageSize
            }
        },()=>{
            this.onRefPageCommonChild.isShowTop();
            this.getList();
        })
    }

    // 导出
    onClickExport(){
        downloadExcel({}).then(res => {
            const data = res.data||{};
            const {success,valid,model} = data;
            if (success && valid) {
                if(model&&model.fileUrl){
                    window.open(model.fileUrl)
                }else message.info(Lang({id:"ZanWuShuJu",default:"暂无数据"}));
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }

    // 上传填充
    onClickUpLoad(fileId){
        this.setState({
            loading: true
        },()=>{
            postHandelExcel({
                fileId:fileId
            }).then(res => {
                const data = res.data||{};
                const {success,valid,model={}} = data;
                this.setState({
                    loading:false
                },()=>{
                    if (success && valid) {
                        if(model.fail||model.success){
                            message.info(Lang({id:"ChengGongGengXinNTiaoShuJuNTiaoShiBai",default:"成功更新{0}条数据，{1}条失败",params:[model.success,model.fail]}));
                        }
                        this.setState({
                            pagination:Object.assign(this.state.pagination,{
                                pageNum:1
                            })
                        })
                        this.getList();
                    } else if(data.message){
                        message.info(data.message);
                    }else {
                        message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}))
                    };
                });
            })
        })
    }

    /**
     * 上传文件后设置
     * **/
    handleUpload(file=[]){
        if(file.length>0){
            const fileId = file[0].fileId;
            this.onClickUpLoad(fileId)
        }
    }

    componentDidMount() {
        this.getList()
    }

    render() {
        const { tabKey } = this.state;
        const currPageName = Lang({id: "ShouHouSuoPei",default: "售后索赔"});
        const uploadSetting = this.state.uploadSetting;
        let btnList = [];
        if(tabKey=='2'){
            btnList = [{
                btn: Lang({id:"DaoChu",default:"导出"}),
                icon:"ri-download-2-line mr_4 color-blue",
                btnClick:()=>this.onClickExport()
            },{
                btn: <UploadFile {...uploadSetting}
                                 onChange={(fileList)=>{
                                     this.handleUpload(fileList);
                                 }}>
                    <i className='ri-upload-cloud-line color-yellow mr_4'></i> <span style={{color:'#fff'}}>{Lang({id:'PiLiangChuLi',default:'批量处理'})}</span>
                </UploadFile>
            }]
        }
        let crumb = [];
        if(this.key=='customerInitiated'){
            crumb = [
                {name:Lang({id: "ShouHouSuoPei",default: "售后索赔"})},
                {name:Lang({id: "KeHuFaQi",default: "客户发起"})}
            ]
        }else{
            crumb = [
                {name:Lang({id: "ShouHouSuoPei",default: "售后索赔"})},
                {name:Lang({id: "CangKuFaQi",default: "仓库发起"})}
            ]
        }
        return (
            <div>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="customer-screen" style={{marginBottom: '0'}}>
                    <Tabs defaultActiveKey="auditing"
                          onChange={this.tabsOnChange.bind(this)}
                          items={[
                              {
                                  key: '1',
                                  label:( <div>
                                    <span className="mr_4">
                                        { Lang({id: 'DaiChuLi', default: '待处理'})}
                                    </span>
                                    <Badge count={this.state.waitHandleNum}></Badge>
                                  </div>),
                              },
                              {
                                  key: '2',
                                  label:( <div>
                                        <span className="mr_4">
                                            { Lang({id: 'DaiHuKuan', default: '待汇款'})}
                                        </span>
                                      <Badge count={this.state.waitPyaNum}></Badge>
                                  </div>),
                              },
                              {
                                  key: '3',
                                  label:( <div>
                                    <span className="mr_4">
                                            { Lang({id: 'YiChuLi', default: '已处理'})}
                                        </span>
                                      {/*<Badge count={99}></Badge>*/}
                                  </div>),
                              },
                          ]}
                    >
                    </Tabs>
                </div>

                <div className="after-sale-audit">
                    {/* 提货提醒 */}
                    {tabKey=='1'?<div className={"mb_12 alertMsg"}>
                            <Alert className={"mb_12"} description={<div dangerouslySetInnerHTML={{__html:Lang({id:"DaiBanTiShiTiDaiChuLiSuoPei",
                            default:'<p><b>你应在客户发起索赔的15天内完成审核。</b>根据公司索赔的标准先判断赔偿是否合理，再接受或拒绝客户的赔偿要求。特殊情况可与客户协商赔偿解决方案。</p>'})}}></div>} type="info" showIcon
                           icon={<i className="ri-information-fill" style={{fontSize: "18px", marginTop: "10px", marginRight: "4px"}} />} />
                    </div>:null}
                    <InputForm getFormData={(data) => {
                        this.getFormData(data)
                    }}></InputForm>

                    <PageCommon onRef={(ref) => {
                        this.onRefPageCommonChild = ref;
                    }}
                                btnList={btnList}>
                        <Spin spinning={this.state.loading}>
                            <AfterSaleContent type={this.state.tabKey} list={this.state.list}
                                              sourceKey={this.key}
                            ></AfterSaleContent>

                            {/*无数据*/}
                            {!this.state.list.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

                            {/*分页器*/}
                            {
                                this.state.list.length>0?
                                    <div className="pagination-box">
                                        <Pagination showQuickJumper
                                                    current={this.state.pagination.pageNum || 1}
                                                    defaultPageSize={this.state.pagination.pageSize}
                                                    total={this.state.pagination.total}
                                                    style={{marginTop: '0'}}
                                                    showSizeChanger={true}
                                                    showTotal={(total) => `Total ${total} items`}
                                                    onChange={this.paginationOnChange.bind(this)} />

                                    </div>:null
                            }

                        </Spin>
                    </PageCommon>
                </div>

            </div>
        )
    }
}

export default AfterSale
